// extracted by mini-css-extract-plugin
export default {"slideContainer":"afa5b46395 _2a8a39b5c2 _8b74dd3f91","slideImage":"_2b75024e39"};